"use client";
import "../chunk-N3ETBM74.js";
import { jsx } from "react/jsx-runtime";
import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { deleteSession } from "../utils";
const LogoutButton = ({ text, locale }) => {
  const { inProgress, instance } = useMsal();
  const handleLogout = async () => {
    await deleteSession();
    await instance.logoutRedirect({
      postLogoutRedirectUri: `/${locale}`
    });
  };
  return /* @__PURE__ */ jsx("div", { className: "w-full", "data-e2e-logout": true, children: /* @__PURE__ */ jsx(
    "button",
    {
      type: "button",
      className: "font-primitive-dfds-sans font-primitive-medium tracking-primitive-0 align-middle text-pretty text-primitive-16 leading-primitive-24 md:text-primitive-16 md:leading-primitive-24 lg:text-primitive-16 lg:leading-primitive-24 border-semantic-global-primary-darkest text-semantic-global-text-default hover:bg-semantic-form-controls-background-ghost-hover hover:text-semantic-global-primary-darkest active:bg-semantic-form-controls-background-ghost-pressed active:text-semantic-global-primary-darkest py-semantic-global-xs px-semantic-global-md gap-semantic-global-xs flex w-full cursor-pointer flex-row items-center justify-center border border-solid disabled:cursor-not-allowed disabled:opacity-50",
      onClick: handleLogout,
      disabled: inProgress !== InteractionStatus.None,
      children: text
    }
  ) });
};
var LogoutButton_default = LogoutButton;
export {
  LogoutButton_default as default
};
